import axios from "axios";
import React, { useEffect, useState } from "react";
import styles from "./styles.css";
import Select from "react-select";
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  Label,
} from "reactstrap";
import { URL_API } from "variable";
import { Editor } from "react-draft-wysiwyg";
import { EditorState } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useHistory } from "react-router-dom";

import { toast } from "react-toastify";
toast.configure();

function CreateTimeSlot() {

  const history = useHistory();
  const [name, setName] = useState();
  const [tagFor, setFor] = useState();

  useEffect(() => {
    let token = localStorage.getItem("token");

  }, []);

  const onNameChange = (e) => {
    setName([e.target.value]);
  };

  const onTagForChange = (e) => {
    setFor([e.target.value]);
  };


  const onSubmit = (event) => {
    event.preventDefault();

    let formData = new FormData();
    formData.append("title", name);
    formData.append("category_for", tagFor);


    axios
      .post(URL_API + "auth/admin/category", formData)
      .then((response) => {
        if (response.status == 200) {
          history.push("/admin/categories");
          toast.success("Category Added Successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
          setName("");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <div className="content">
        <form onSubmit={(e) => onSubmit(e)}>
          <div className={`container-fluid`}>
            <div className={styles.HeroiImgBlogForm}>
              <div className={styles.paddingTopBottomBlogForm}>
                <h3 className={styles.HeroiImgTextBlogForm}>Add Time Slot</h3>
              </div>
            </div>
            <br />
            <div className="container">
              <div className={`form ${styles.blogPostForm}`}>
                <div className="form-group">
                  <label htmlFor="post-title" className={styles.labelPostForm}>
                    Name
                  </label>
                  <Input
                    name="title"
                    type="text"
                    //   class={`form-control ${styles.blogPostFormInput}`}
                    id="post-title"
                    required="required"
                    placeholder="Plots..."
                    onChange={(e) => onNameChange(e)}
                  />
                </div>
                <br />
                <div className="form-group">
                  <label htmlFor="post-title" className={styles.labelPostForm}>
                    Category For
                  </label>
                  <Input
                    name="title"
                    type="text"
                    //   class={`form-control ${styles.blogPostFormInput}`}
                    id="post-title"
                    required="required"
                    placeholder="Enter   estate , jobs , cars"
                    onChange={(e) => onTagForChange(e)}
                  />
                </div>
                <br />

                <Input
                  type="submit"
                  name="submit"
                  className={`btn btn-danger ${styles.blogPostFormBtn}`}
                  value="Submit"
                />
              </div>
              <br />
              <br />
            </div>
          </div>
          {/* <BlogForm handleChange={handleChange} /> */}
        </form>
      </div>
    </>
  );
}

export default CreateTimeSlot;
